import Service, { inject as service } from '@ember/service';

/**
 * @param {Model|string} maybeModel
 * @returns {string}
 */
const modelToId = (maybeModel) => typeof maybeModel === 'string'
  ? maybeModel
  : maybeModel.id;

class CompanyConnectionCommands extends Service {
  @service('error-tracker')
  errorTracker;

  @service
  api;

  /**
   *
   * @param {Company|string} companyOrId
   * @param {User|string} sellerOrId
   * @param {boolean} follow
   * @returns {Promise<void>}
   */
  async updateNetworkConnection(companyOrId, sellerOrId, invited = null, follow = null) {
    const companyId = modelToId(companyOrId);
    const sellerId = modelToId(sellerOrId);

    const options = {
      jsonData: {},
    };

    if (invited !== null) {
      options.jsonData.invited = invited ? 1 : 0;
    }

    if (follow !== null) {
      options.jsonData.follow = follow ? 1 : 0;
    }

    try {
      await this.api.put(`companies/${companyId}/freelancer-connection/${sellerId}`, options);
    } catch (e) {
      this.errorTracker.error(e, this, `Error updating company connection between company [${companyId}] and seller [${sellerId}]`)
      throw e;
    }
  }

  /**
   *
   * @param {Application|string} applicationOrId
   * @param {boolean} isFMS
   * @returns {Promise<void>}
   */
  async updateApplicationFMSStatus(applicationOrId, isFMS) {
    const applicationId = modelToId(applicationOrId);

    const url = isFMS
      ? `applications/${applicationId}/make-fms`
      : `applications/${applicationId}/remove-fms`;

    try {
      await this.api.post(url);
    } catch (e) {
      this.errorTracker.error(e, this, `Error updating FMS status on application [${applicationId}]`);
      throw e;
    }
  }
}

export default CompanyConnectionCommands;
